export default (state = {level: 0, msg: ''}, action) => {
  if (typeof action.apiHandle !== 'undefined') {
    return action.apiHandle;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducer/apiHandle.js